<template>
  <v-content>
    <v-layout container align-center justify-center wrap rows fill-height>
      <v-flex xs-12 sm10 md8>
        <v-card class="mx-auto">
          <v-card-actions class="pa-0">
            <v-btn
              :flat="step === 2"
              @click="step = 1"
              block
              depressed
              color="primary"
            >
              Register
            </v-btn>

            <v-btn
              :flat="step === 1"
              color="primary"
              depressed
              @click="step = 2"
              block
              class="ma-0"
            >
              Login
            </v-btn>
          </v-card-actions>

          <v-divider></v-divider>

          <v-layout justify-center row mt-5>
            <v-img :src="logo" max-width="250"/>
          </v-layout>

          <v-window v-model="step">
            <v-window-item :value="1">
              <register />
            </v-window-item>

            <v-window-item :value="2">
              <login />
            </v-window-item>
          </v-window>

          <v-card-text class="text-xs-center">
            <a @click="step=2" v-if="step === 1">Already registered? Click here to log in.</a>
            <a @click="step=1" v-if="step === 2">Not signed up yet? Click here to register.</a>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import Register from '@/components/Register'
import Login from '@/components/Login'

  export default {
    components: {
        Register,
        Login
    },
    data: () => ({
      step: 1,
      logo: require('@/assets/leapq-logo.jpg'),
    }),
    mounted() {
        if(this.$route.name == 'login') this.step = 2
    }
  }
</script>

<style scoped>
  .theme--light.v-card {
    border-color: white;
  }

  .v-card__actions {
    border: 0;
    padding: 0;
  }

  .v-card__actions button {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .v-card__actions .v-btn {
    font-family: 'Montserrat', sans-serif;
  }
</style>
